'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _main = require('./main.c');

var _main2 = _interopRequireDefault(_main);

var _dataModel = require('../../../common/backbone/dataModel');

var _dataModel2 = _interopRequireDefault(_dataModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_View) {
    _inherits(_class, _View);

    function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
        key: 'processModelData',


        /**
         * override from Base
         * if __forceSubmit flag is passed
         * this.submit method is called after component:ready
         * @param {object} prevParams
         * @param {object} nextParams
         * @param {object} opts
         * @return {object}
         */
        value: function processModelData(prevParams, nextParams) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'processModelData', this).call(this, prevParams, nextParams, opts);

            if (!nextParams || (typeof nextParams === 'undefined' ? 'undefined' : _typeof(nextParams)) !== 'object' || typeof this.submit !== 'function' || !this.isUiInteractive()) {
                return this;
            }

            if ((!prevParams || !prevParams.__forceSubmit) && !!nextParams.__forceSubmit) {
                this.submit();
            }

            return this;
        }
    }, {
        key: 'componentReady',
        value: function componentReady() {
            if (this.props.params && this.props.params.__forceSubmit && typeof this.submit === 'function') {
                this.submit();
            }
        }

        /**
         * form submit event default callback
         * @param {object} event
         * @return {object}
         */

    }, {
        key: 'submit',
        value: function submit() {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (event.nativeEvent) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (typeof this.componentWillSubmit === 'function') {
                this.componentWillSubmit();
            }

            var data = this.getFormData(),
                model = this.getModel();

            if (typeof this.componentDidSubmit === 'function' && typeof this.validate === 'function' && this.validate(data)) {
                this.componentDidSubmit(data, model);
            }

            return this;
        }

        /**
         * Component lifecycle method
         * It should be run AFTER success completion of this.submit processing
         * @param {object} data
         * @param {object} model
         */

    }, {
        key: 'componentDidSubmit',
        value: function componentDidSubmit() {
            var _this2 = this;

            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var model = arguments[1];

            this.uiStandBy();

            if (model instanceof _dataModel2.default) {
                model.save(data).then(function (response) {
                    if (typeof _this2.props.toNextStep === 'function') {
                        _this2.props.toNextStep();
                    }
                }, function (error) {
                    return _this2.errorHandler(error);
                });
            } else {
                if (typeof this.props.toNextStep === 'function') {
                    this.props.toNextStep(data);
                }
            }
        }

        /**
         * Component lifecycle method
         * It should be run BEFORE this.submit processing
         */
        /* componentWillSubmit() {
        }*/

    }]);

    return _class;
}(_main2.default);

_class.displayName = 'Base.Views.Form';
exports.default = _class;